export const IntegrationMappersUAD36Columns = {
	model: [
		{
			label: 'Field',
			key: 'field',
			type: 'select',
			options: []
		},
		{
			label: 'Integration Id',
			key: 'key'
		},
		{
			label: 'Integration Label',
			key: 'label'
		},
		{
			label: 'Tracking System',
			key: 'trackingSystem',
			type: 'select',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
				{ label: 'Acuity', value: 'cmpAcuity' },
			],
			onChange: ($event: any, row: any, model: any, integrationData: any, extraData: any) => {

				switch ($event.value) {
					case 'Acuity':
						model[3].options = extraData.acuityOptions;
						break;
					case 'AppScope':
						model[3].options = extraData.appScopeOptions;
						break;
					case 'cmpAcuity':
						model[3].options = extraData.appScopeOptions;
						break;
					default:
						model[3].options = [];
						break;

				}

				if (model[3].options[0]) {
					const selectedValue = model[3].options[0];

					integrationData[row.id] = {
						...row,
						...{
							trackingSystemId: selectedValue.value,
							trackingSystemLabel: selectedValue.label
						}
					};
				}
			}
		},
		{
			label: 'Tracking System Id',
			key: 'trackingSystemId'
		},
		{
			label: 'Tracking System Label',
			key: 'trackingSystemLabel'
		}
	],
	formBuilderConfig: {
		field: {
			DataType: 'Selector',
			DisplayText: 'Field',
			Name: 'field',
			type: 'select',
			UIControl: 'Dropdown',
			options: [],
		},
		key: {
			DataType: 'String',
			DisplayText: 'Integration Id',
			Name: 'key'
		},
		label: {
			DataType: 'String',
			DisplayText: 'Integration Label',
			Name: 'label'
		},
		trackingSystem: {
			DataType: 'Selector',
			DisplayText: 'Tracking System',
			Name: 'trackingSystem',
			UIControl: 'Dropdown',
			options: [],
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
					model['trackingSystemId'].options = [];

					if($event.value) {
						const trackingSystemOptionsName = $event.value[0].toLowerCase() + $event.value.substring(1);
						model['trackingSystemId'].options = extraData[trackingSystemOptionsName];
					}

					if (formGroup) {
						formGroup.get('trackingSystemId')?.setValue(null);
						formGroup.get('trackingSystemLabel')?.setValue(null);
					}
				}
			}
		},
		trackingSystemId: {
			DataType: 'String',
			DisplayText: 'Tracking System Id',
			Name: 'trackingSystemId'
		},
		trackingSystemLabel: {
			DataType: 'String',
			DisplayText: 'Tracking System Label',
			Name: 'trackingSystemLabel'
		},
		mapType: {
			DataType: 'String',
			DisplayText: 'Mapper Type',
			Name: 'mapType',
			hidden: true,
			required: false
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
}
